import { defaultProps, SearchContentsProps } from "./SearchContents";

const dangerouslyComposeProps = (
    rootElement: Element | null
): SearchContentsProps => {
    if (!rootElement) {
        return defaultProps;
    }

    const { cms } = globalThis;
    const components = cms?.page?.components;

    if (typeof components === "undefined") {
        return defaultProps;
    }

    const componentProps = components.find(
        (component) => component.name?.toLowerCase() === "searchcontents"
    );
    if (!componentProps) {
        return defaultProps;
    }
    const props = {
        ...componentProps,
    };

    /*
     * cms.site.searchEngine.endpointOrigin is printed in the site Document Head
     * partial and maps to site metadata text field
     * %globals_site_metadata_ripple.site.fb.url^striphtml^htmlentities:ENT_QUOTES^trim%
     */
    const endpointOrigin = cms?.site?.searchEngine?.endpointOrigin ?? "";
    const endpoint = `${endpointOrigin}/s/search.json`;
    props.searchConfig.endpoint = endpoint;

    return props;
};

export default dangerouslyComposeProps;
